export const lastUsageDeclarationPerCategoryTableColumns = [
  { value: 'transaction_id', label: 'Transação' },
  { value: 'product_category', label: 'Serviço' },
  { value: 'created_at', label: 'Data' },
  { value: 'value', label: 'Últ. Consumo Informado' },
  { value: 'author', label: 'Autor' },
  { value: 'actions', label: 'Ações', className: 'w-11' },
];
